<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '~~/src/helpers'

const props = defineProps<{
  initials: string
  class?: HTMLAttributes['class']
}>()
const backgroundColors = ['#F499D5', '#D496F1', '#BABAFF', '#858AFE', '#D8F0BA', '#D7F7D0', '#D3F2FF']

function getInitials() {
  return props.initials.split(' ').slice(0, 2).map(word => word[0]).join('').toUpperCase()
}

function getBackgroundColors() {
  const nameToIndex = props.initials.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  return backgroundColors[nameToIndex % backgroundColors.length]
}
</script>

<template>
  <div
    :class="cn('w-full h-full aspect-square flex items-center justify-center rounded-2 text-white text-sm font-bold capitalize text-6xl leading-none select-none pointer-events-none font-inter filter-drop-shadow-sm', $props.class)"
    :style="{ backgroundColor: getBackgroundColors() }"
  >
    <span>{{ getInitials() }}</span>
  </div>
</template>
